export const ExpiredIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Icon / Cross">
			<path
				id="Vector"
				d="M14.1673 5.8335L5.83398 14.1668"
				stroke="#B8B8BB"
				strokeWidth="1.5"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path
				id="Vector_2"
				d="M5.83398 5.8335L14.1673 14.1668"
				stroke="#B8B8BB"
				strokeWidth="1.5"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
